export default {"src":"/_next/static/media/live.54a08ee8.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};